import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

import AutonomoRow from './AutonomoRow.react';

export default class AutonomoTable extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    searchWithPage: PropTypes.func.isRequired
  };

  renderAutonomos = data => {
    const key = `${data.get('entidade')}_${data.get('codigo')}`;

    return (
      <AutonomoRow key={key} autonomo={data} history={this.props.history} />
    );
  };

  render() {
    const { page, usaWebService, searchWithPage } = this.props;

    let autonomos;
    if (page) {
      autonomos = page.get('content');
    }

    if (!autonomos) {
      return null;
    }
    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader
            empty={autonomos.isEmpty()}
            text="Não foi encontrado nenhum autonomo para a pesquisa selecionada."
          >
            <tr>
              <TableHeaderItem
                field="nome"
                label="Nome do(a) Autonômo(a)"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field="matricula"
                label="Matrícula"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field="situacao"
                label="Situação"
                page={page}
                searchWithPage={searchWithPage}
              />
              {!usaWebService && (
                <TableHeaderItem
                  field="descricaoClasse"
                  label="Classe / Natureza"
                  page={page}
                  searchWithPage={searchWithPage}
                />
              )}
              <TableHeaderItem
                field="descricaoLotacao"
                label="Lotação"
                page={page}
                searchWithPage={searchWithPage}
              />
              <th />
            </tr>
          </TableHeader>

          <tbody>{autonomos.map(this.renderAutonomos)}</tbody>
        </table>
      </div>
    );
  }
}
